
$(document).ready(function() {
  let vatTax = 16.66;
    setTimeout(function() {
      let counter = 0;
      
      console.log('vat tax rate' + vatTax)
         $.getJSON('/cart.js', function(cart) {
         $.each(cart.items, function(index, item) {
            counter++;
            //   let extraPrice = parseFloat(item.properties._cl_options_price);
            //  console.log('test ' + extraPrice);
            // let orignalProductPrice = parseFloat(item.final_line_price);
            // let vatPrice = parseFloat(orignalProductPrice * 16.66 / 100);
            // let printPrice = orignalProductPrice - vatPrice;
            let extraPrice = parseFloat(item.properties._cl_options_price);
           let itemQty = item.quantity;
           console.log(itemQty)
           let finalExtraPrice = extraPrice * itemQty;
            let orignalProductPrice = parseFloat(item.original_line_price);
            let lineItemPrice = parseFloat(orignalProductPrice);
            let vatPrice = parseFloat(lineItemPrice * vatTax / 100);
           
            let printPrice = lineItemPrice - vatPrice;
           // console.log("lineItemPrice " + finalExtraPrice)
            let orgPrice = item.original_line_price;
            let vatPerPrice = orgPrice * vatTax / 100;
            let excPrice = orgPrice - vatPerPrice;
            let test = parseFloat(orgPrice * vatTax / 100);
            let test1 = parseFloat(orgPrice - test);
           
           
            let itemId = item.id;
          
             if(item.properties._cl_options_price){
            $('#excfinalprice_' + counter  + itemId).html(Shopify.formatMoney(printPrice, $('body').attr('data-money-format')) + ' (Ex VAT)');
            }else{
                $('#excfinalprice_' + counter  + itemId).html(Shopify.formatMoney(test1, $('body').attr('data-money-format')) + ' (Ex VAT)');
            }
            

        });
      });
       $('.new__price').append("<span class='js_vat_test'> (Inc VAT)</span>");
        //$('[data-live-format]').append("(inc Tax)");
        //$('.booster-cart-item-line-price').append("(inc Tax)");
        let customPrice = $('.js_pro_reg_price').attr('data-live-format').replace('£', '');

        let excVatPriceCustom = customPrice * vatTax / 100;

        let taxExcPrice = (customPrice - excVatPriceCustom).toFixed(2);
        $('.js_ex_price').html('£' + taxExcPrice + '(Ex VAT)')


    }, 500);




    setTimeout(function() {}, 5000);
    let counter = 0;
    $.getJSON('/cart.js', function(cart) {
        $.each(cart.items, function(index, item) {
            counter++;
            let extraPrice = parseFloat(item.properties._cl_options_price);
            let orignalProductPrice = parseFloat(item.price);
            let lineItemPrice = parseFloat(orignalProductPrice);
            let vatPrice = parseFloat(lineItemPrice * vatTax / 100);
            let printPrice = lineItemPrice - vatPrice;
            console.log('VatPrice'+vatPrice);
            let orgPrice = item.final_price;
            let vatPerPrice = orgPrice * vatTax / 100;
            let excPrice = orgPrice - vatPerPrice;
            let test = parseFloat(orignalProductPrice * vatTax / 100);
            let test1 = parseFloat(orignalProductPrice - test);
           
            let itemId = item.id
          
             if(item.properties._cl_options_price){
            $('#excprice_' + counter  + itemId).html(Shopify.formatMoney(printPrice, $('body').attr('data-money-format')) + ' (Ex VAT)');
            }else{
                $('#excprice_' + counter  + itemId).html(Shopify.formatMoney(test1, $('body').attr('data-money-format')) + ' (Ex VAT)');
            }

        });
      });
      



    $(document).on("keyup click", "input[type='text'], .cl-po--swatch", function() {
        setTimeout(function() {
              //$('[data-live-format]').append("(inc Tax)");
            let customPrice = $('.js_pro_reg_price').attr('data-live-format').replace('£', '');

        
            let excVatPriceCustom = customPrice * vatTax / 100;

            let taxExcPrice = (customPrice - excVatPriceCustom).toFixed(2);
            $('.js_ex_price').html('£' + taxExcPrice + '(Ex VAT)')
        }, 500);
    });
});